// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/datagateway/v1/win_themes.proto (package mono.datagateway.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
/**
 * SAD-506: versioned Win Themes derived from accepted Customer Themes.
 * A proof link names an evidence row or Pursuit document. When the caller cannot
 * access the target, accessible is false and label carries no content.
 *
 * @generated from message mono.datagateway.v1.WinThemeProofLink
 */ export class WinThemeProofLink extends Message {
    static fromBinary(bytes, options) {
        return new WinThemeProofLink().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WinThemeProofLink().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WinThemeProofLink().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WinThemeProofLink, a, b);
    }
    constructor(data){
        super(), /**
   * evidence | document
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string id = 2;
   */ _define_property(this, "id", ""), /**
   * Evidence excerpt or document name; empty when !accessible.
   *
   * @generated from field: string label = 3;
   */ _define_property(this, "label", ""), /**
   * @generated from field: bool accessible = 4;
   */ _define_property(this, "accessible", false);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WinThemeProofLink, "runtime", proto3);
_define_property(WinThemeProofLink, "typeName", "mono.datagateway.v1.WinThemeProofLink");
_define_property(WinThemeProofLink, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "accessible",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WinThemeClaim
 */ export class WinThemeClaim extends Message {
    static fromBinary(bytes, options) {
        return new WinThemeClaim().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WinThemeClaim().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WinThemeClaim().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WinThemeClaim, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string claim_text = 1;
   */ _define_property(this, "claimText", ""), /**
   * True only when at least one proof link is present.
   *
   * @generated from field: bool supported = 2;
   */ _define_property(this, "supported", false), /**
   * @generated from field: repeated mono.datagateway.v1.WinThemeProofLink proof_links = 3;
   */ _define_property(this, "proofLinks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WinThemeClaim, "runtime", proto3);
_define_property(WinThemeClaim, "typeName", "mono.datagateway.v1.WinThemeClaim");
_define_property(WinThemeClaim, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "claim_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "supported",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 3,
            name: "proof_links",
            kind: "message",
            T: WinThemeProofLink,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WinThemeVersion
 */ export class WinThemeVersion extends Message {
    static fromBinary(bytes, options) {
        return new WinThemeVersion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WinThemeVersion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WinThemeVersion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WinThemeVersion, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: int32 version = 2;
   */ _define_property(this, "version", 0), /**
   * Lineage to the Customer Theme revision.
   *
   * @generated from field: string customer_theme_version_id = 3;
   */ _define_property(this, "customerThemeVersionId", ""), /**
   * @generated from field: string need_summary = 4;
   */ _define_property(this, "needSummary", ""), /**
   * @generated from field: string differentiator = 5;
   */ _define_property(this, "differentiator", ""), /**
   * @generated from field: string narrative = 6;
   */ _define_property(this, "narrative", ""), /**
   * @generated from field: string created_by = 7;
   */ _define_property(this, "createdBy", ""), /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */ _define_property(this, "createdAt", void 0), /**
   * @generated from field: repeated mono.datagateway.v1.WinThemeClaim claims = 9;
   */ _define_property(this, "claims", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WinThemeVersion, "runtime", proto3);
_define_property(WinThemeVersion, "typeName", "mono.datagateway.v1.WinThemeVersion");
_define_property(WinThemeVersion, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "customer_theme_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "need_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "differentiator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 9,
            name: "claims",
            kind: "message",
            T: WinThemeClaim,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WinTheme
 */ export class WinTheme extends Message {
    static fromBinary(bytes, options) {
        return new WinTheme().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WinTheme().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WinTheme().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WinTheme, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string pursuit_id = 2;
   */ _define_property(this, "pursuitId", ""), /**
   * @generated from field: string customer_theme_id = 3;
   */ _define_property(this, "customerThemeId", ""), /**
   * Lineage of the latest version.
   *
   * @generated from field: string customer_theme_version_id = 4;
   */ _define_property(this, "customerThemeVersionId", ""), /**
   * @generated from field: string customer_theme_title = 5;
   */ _define_property(this, "customerThemeTitle", ""), /**
   * @generated from field: string need_summary = 6;
   */ _define_property(this, "needSummary", ""), /**
   * @generated from field: string differentiator = 7;
   */ _define_property(this, "differentiator", ""), /**
   * @generated from field: string narrative = 8;
   */ _define_property(this, "narrative", ""), /**
   * Latest version number.
   *
   * @generated from field: int32 version = 9;
   */ _define_property(this, "version", 0), /**
   * Author of the latest version.
   *
   * @generated from field: string created_by = 10;
   */ _define_property(this, "createdBy", ""), /**
   * Creation of the latest version.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */ _define_property(this, "createdAt", void 0), /**
   * Source Customer Theme moved on since the latest version.
   *
   * @generated from field: bool stale_lineage = 12;
   */ _define_property(this, "staleLineage", false), /**
   * @generated from field: repeated mono.datagateway.v1.WinThemeClaim claims = 13;
   */ _define_property(this, "claims", []), /**
   * Ascending; filled only by GetWinThemeHistory.
   *
   * @generated from field: repeated mono.datagateway.v1.WinThemeVersion versions = 14;
   */ _define_property(this, "versions", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WinTheme, "runtime", proto3);
_define_property(WinTheme, "typeName", "mono.datagateway.v1.WinTheme");
_define_property(WinTheme, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pursuit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "customer_theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "customer_theme_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "customer_theme_title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "need_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "differentiator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 10,
            name: "created_by",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "created_at",
            kind: "message",
            T: Timestamp
        },
        {
            no: 12,
            name: "stale_lineage",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 13,
            name: "claims",
            kind: "message",
            T: WinThemeClaim,
            repeated: true
        },
        {
            no: 14,
            name: "versions",
            kind: "message",
            T: WinThemeVersion,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.WinThemeClaimInput
 */ export class WinThemeClaimInput extends Message {
    static fromBinary(bytes, options) {
        return new WinThemeClaimInput().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WinThemeClaimInput().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WinThemeClaimInput().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WinThemeClaimInput, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string claim_text = 1;
   */ _define_property(this, "claimText", ""), /**
   * Only kind and id are read.
   *
   * @generated from field: repeated mono.datagateway.v1.WinThemeProofLink proof_links = 2;
   */ _define_property(this, "proofLinks", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(WinThemeClaimInput, "runtime", proto3);
_define_property(WinThemeClaimInput, "typeName", "mono.datagateway.v1.WinThemeClaimInput");
_define_property(WinThemeClaimInput, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "claim_text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "proof_links",
            kind: "message",
            T: WinThemeProofLink,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListWinThemesRequest
 */ export class ListWinThemesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListWinThemesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWinThemesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWinThemesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWinThemesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string pursuit_id = 3;
   */ _define_property(this, "pursuitId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWinThemesRequest, "runtime", proto3);
_define_property(ListWinThemesRequest, "typeName", "mono.datagateway.v1.ListWinThemesRequest");
_define_property(ListWinThemesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "pursuit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.ListWinThemesResponse
 */ export class ListWinThemesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListWinThemesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListWinThemesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListWinThemesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListWinThemesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.datagateway.v1.WinTheme win_themes = 1;
   */ _define_property(this, "winThemes", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListWinThemesResponse, "runtime", proto3);
_define_property(ListWinThemesResponse, "typeName", "mono.datagateway.v1.ListWinThemesResponse");
_define_property(ListWinThemesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "win_themes",
            kind: "message",
            T: WinTheme,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveWinThemeVersionRequest
 */ export class SaveWinThemeVersionRequest extends Message {
    static fromBinary(bytes, options) {
        return new SaveWinThemeVersionRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveWinThemeVersionRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveWinThemeVersionRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveWinThemeVersionRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string pursuit_id = 3;
   */ _define_property(this, "pursuitId", ""), /**
   * Empty creates; set appends a version.
   *
   * @generated from field: string win_theme_id = 4;
   */ _define_property(this, "winThemeId", ""), /**
   * Required on create; ignored on append.
   *
   * @generated from field: string customer_theme_id = 5;
   */ _define_property(this, "customerThemeId", ""), /**
   * Empty defaults to the theme's current version.
   *
   * @generated from field: string customer_theme_version_id = 6;
   */ _define_property(this, "customerThemeVersionId", ""), /**
   * @generated from field: string need_summary = 7;
   */ _define_property(this, "needSummary", ""), /**
   * @generated from field: string differentiator = 8;
   */ _define_property(this, "differentiator", ""), /**
   * @generated from field: string narrative = 9;
   */ _define_property(this, "narrative", ""), /**
   * @generated from field: repeated mono.datagateway.v1.WinThemeClaimInput claims = 10;
   */ _define_property(this, "claims", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveWinThemeVersionRequest, "runtime", proto3);
_define_property(SaveWinThemeVersionRequest, "typeName", "mono.datagateway.v1.SaveWinThemeVersionRequest");
_define_property(SaveWinThemeVersionRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "pursuit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "win_theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "customer_theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "customer_theme_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "need_summary",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "differentiator",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "narrative",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "claims",
            kind: "message",
            T: WinThemeClaimInput,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.SaveWinThemeVersionResponse
 */ export class SaveWinThemeVersionResponse extends Message {
    static fromBinary(bytes, options) {
        return new SaveWinThemeVersionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SaveWinThemeVersionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SaveWinThemeVersionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SaveWinThemeVersionResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WinTheme win_theme = 1;
   */ _define_property(this, "winTheme", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SaveWinThemeVersionResponse, "runtime", proto3);
_define_property(SaveWinThemeVersionResponse, "typeName", "mono.datagateway.v1.SaveWinThemeVersionResponse");
_define_property(SaveWinThemeVersionResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "win_theme",
            kind: "message",
            T: WinTheme
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetWinThemeHistoryRequest
 */ export class GetWinThemeHistoryRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetWinThemeHistoryRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWinThemeHistoryRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWinThemeHistoryRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWinThemeHistoryRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string tenant_id = 1;
   */ _define_property(this, "tenantId", ""), /**
   * @generated from field: string user_id = 2;
   */ _define_property(this, "userId", ""), /**
   * @generated from field: string pursuit_id = 3;
   */ _define_property(this, "pursuitId", ""), /**
   * @generated from field: string win_theme_id = 4;
   */ _define_property(this, "winThemeId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWinThemeHistoryRequest, "runtime", proto3);
_define_property(GetWinThemeHistoryRequest, "typeName", "mono.datagateway.v1.GetWinThemeHistoryRequest");
_define_property(GetWinThemeHistoryRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "tenant_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "user_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "pursuit_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "win_theme_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.datagateway.v1.GetWinThemeHistoryResponse
 */ export class GetWinThemeHistoryResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetWinThemeHistoryResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetWinThemeHistoryResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetWinThemeHistoryResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetWinThemeHistoryResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.WinTheme win_theme = 1;
   */ _define_property(this, "winTheme", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetWinThemeHistoryResponse, "runtime", proto3);
_define_property(GetWinThemeHistoryResponse, "typeName", "mono.datagateway.v1.GetWinThemeHistoryResponse");
_define_property(GetWinThemeHistoryResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "win_theme",
            kind: "message",
            T: WinTheme
        }
    ]));
